import { useAuth0 } from "@auth0/auth0-react";
import { useState, useEffect, createContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { svc_getUser, svc_getUserPreferences } from "../services/user.service";
import * as Preferences from '../constants/USER_PREFERENCE';
const UserContext = createContext(null);

const UserProvider = ({ children }) => {
    const { getAccessTokenSilently, user } = useAuth0();
    const navigate = useNavigate();

    const [ddUser, setDDUser] = useState(null)
    const [userProfileCompleted, setUserProfileCompleted] = useState(false)
    const [emailVerified, setEmailVerified] = useState(user?.email_verified)
    const [isInitializing, setIsInitializing] = useState(true);
    const [userPreferences, setUserPreferences] = useState(null)

    const getDDUser = async (userId, force = false) => {
        if (ddUser && !force) return;

        const accessToken = await getAccessTokenSilently();

        const { data, error } = await svc_getUser(accessToken, userId);

        setIsInitializing(false);

        if (error) {
            console.error("Error getting user: ", error);
            setUserProfileCompleted(false);
            return false;
        }

        if (data.length < 1) {
            setUserProfileCompleted(false);

            if (window.location.pathname !== "/profile") {
                navigate("/profile");
            }
        }

        if (data.length === 1) {
            setDDUser({ ...data[0] })
            setUserProfileCompleted(true);
        }

        return data[0];
    }

    const getUserPreferences = async() => {
        const accessToken = await getAccessTokenSilently()
        const { data, error} = await svc_getUserPreferences(accessToken, ddUser.id)

        if (error) {
            console.error("Error getting user preferences: ", error)
            return
        }

        const preferences = data.map(preference => {
            let retVal;
            switch (Preferences.PREF_TYPE[preference.preference_key]) {
                case 'number':
                    retVal = {
                        [preference.preference_key]: parseInt(preference.preference_value)
                    }
                    break;
                case 'boolean':
                    retVal = {
                        [preference.preference_key]: Boolean(parseInt(preference.preference_value))
                    }
                    break;
                default:
                    retVal = {
                        [preference.preference_key]: preference.preference_value
                    }
                    break;
            }
            return retVal
        })

        setUserPreferences(preferences)

        return preferences;
    }

    useEffect(() => {
        if (user) {
            getDDUser(user.sub);
        }
    }, [user]);

    return (
        <UserContext.Provider value={{
            isInitializing,
            user,
            ddUser,
            getDDUser,
            userPreferences,
            getUserPreferences,
            userProfileCompleted,
            setUserProfileCompleted,
            emailVerified,
            setEmailVerified,
        }}>
            {children}
        </UserContext.Provider>
    )
}

export { UserContext, UserProvider }
